var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.12988 3.75927C2.12988 4.62369 2.47327 5.45269 3.0845 6.06393C3.69573 6.67516 4.52473 7.01855 5.38914 7.01855C6.25355 7.01855 7.08256 6.67516 7.69379 6.06393C8.30502 5.45269 8.6484 4.62369 8.6484 3.75927C8.6484 2.89486 8.30502 2.06585 7.69379 1.45462C7.08256 0.843387 6.25355 0.5 5.38914 0.5C4.52473 0.5 3.69573 0.843387 3.0845 1.45462C2.47327 2.06585 2.12988 2.89486 2.12988 3.75927Z",
    stroke: "#3B317F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.5371C0.5 11.6727 0.843385 10.8437 1.45461 10.2325C2.06584 9.62122 2.89485 9.27783 3.75926 9.27783H7.01852C7.88293 9.27783 8.71193 9.62122 9.32316 10.2325C9.93439 10.8437 10.2778 11.6727 10.2778 12.5371",
    stroke: "#3B317F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.fede19d18fdbd92f07418d362de3a887.svg";
export { ForwardRef as ReactComponent };